import { z } from "zod";
export const PortalEnabledBrands = z.object({
    brandId: z.string(),
    brandPersistentId: z.string(),
    designSystemId: z.string(),
    workspaceId: z.string(),
});
